import type { InputData } from "@smartsuite/automation-engine-api";

export const emptyString = (inputId: string): InputData => ({
  inputId,
  value: {
    values: [
      {
        value: { oneofKind: "string", string: "" },
        label: "",
        icon: "",
      },
    ],
    metadata: {},
  },
});
